import { ChartDefinition, ChartGroupByMode, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { STOCK_VOLUME_CHART_ENDPOINT } from '../stock-chart-endpoints';

export const STOCK_VOLUME_BY_SPOT_LINE_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.STOCK_VOLUME_BY_SPOT_LINE,
    chartType: ChartRendererType.LINE,
    endpoint: STOCK_VOLUME_CHART_ENDPOINT,
    filters: [],
    groupBy: ChartQueryParam.SPOT_ID,
    groupByMode: ChartGroupByMode.VALUE
};
